import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoadingAction } from 'src/app/models/loading-action.model';

@Injectable()
export class LoadingService {
  public loading: boolean = false;
  public loadingAction: LoadingAction;
  private eventSubject = new Subject<any>();

  constructor() {
    this.loading = false;
    this.loadingAction = LoadingAction.None;
  }

  private emitEvent(data: any) {
    this.eventSubject.next(data);
  }

  public resetLoadingDocumentIndicator() {
    this.loading = false;
    this.loadingAction = LoadingAction.None;
    this.emitEvent(this.loadingAction);
  }

  public setLoadingAction(loadingAction: LoadingAction) {
    this.loading = true;
    this.loadingAction = loadingAction;
    this.emitEvent(this.loadingAction);
  }

  // Observable to subscribe to events
  get events$() {
    return this.eventSubject.asObservable();
  }
}
